﻿import * as odpUtils from '../integrations/ODP/utils';

//SaveInAs Wishlist modal
const selectBtn = document.querySelector('#saveInWishlistModal .select-btn'),
    items = document.querySelectorAll('#saveInWishlistModal .item input');

var createNew = false;
var saveCartToWishlist = false;
var cartItemMaterialId;
var cartItemQuantity;
var cartItemOrderingCode;

let code = '';

if (selectBtn) {
    selectBtn.addEventListener("click", () => {
        selectBtn.classList.toggle("open");
        event.stopPropagation();
    });
}

let wishlistSelected = [];
items.forEach(item => {
    item.addEventListener("click", () => {
        var selectAll = false;
        if ($(item).attr('id') == 'id_wishlist_select_all') {
            items.forEach(function (node, index) {
                if (index == 0) {
                    selectAll = $(node).is(":checked");
                }
                else {
                    node.classList.toggle('checked');
                    $(node).prop('checked', selectAll);
                    if (selectAll) {
                        $(node).addClass('checked');
                    }
                    wishlistSelected = [];
                }
            })
        }
        else {
            item.classList.toggle("checked");
        }
        var parent = item.closest('.list-items');
        const checked = $(parent).find(".item .checked"),
            btnText = $(parent).prev().find(".btn-text");
        if (checked && checked.length > 0) {
            wishlistSelected = [];
            let selectedText = [];
            for (const child of checked) {
                var wish = "";
                if ($(child).attr('id') == 'id_wishlist_MyDefaultWishList')
                {
                    wish = "My Default Wish List";
                    selectedText.push($(child).next('label').text());
                }
                else
                {
                    wish = $(child).next('label').text();
                    selectedText.push(wish);
                }
                wishlistSelected.push(wish);
                
            }
            $(btnText).text(selectedText);
        }
        else {
            $(btnText).text("select");
        }
        
    })
})
$(".multiple-select-container .list-items").click(function () {
    event.stopPropagation();
});
$('#chbCreateNew').click(function () {
    $("#lbl_Wislist_validation").hide();
    $("#lbl_Wislist_Length_Validation").hide();
    $("#lbl_DWislist_validation").addClass('d-none').removeClass('d-block');
    if ($(this).is(':checked')) {
        $("#saveWishListName").addClass('d-block').removeClass('d-none');
        $('#lbl_wishListName').removeClass('d-block').addClass('d-block');
        $(".multiple-select-container").hide();
        createNew = true
    }
    else {
        $("#saveWishListName").addClass('d-none').removeClass('d-block');
        $('#lbl_wishListName').removeClass('d-block').addClass('d-none');
        $(".multiple-select-container").show();
        createNew = false
    }
});

$("#btnSaveWishlist").click(function () {
    if (validateForm())
    {
        if (createNew) {
            if (saveCartToWishlist) {
                addCartItemToNewWishList();
                return;
            }
            addToNewWishList();
        }
        else {
            if (saveCartToWishlist) {
                addCartItemToExisting();
                return;
            }
            addToExisting();
        }
    }
});
$(".cart-items-page__summary-save-to-wishlist #btn_SaveWishlist").click(function () {
    $("#save_in_wishlist_title").addClass("d-none").removeClass("d-block");
    $("#btnSaveWishlist").addClass("d-none").removeClass("d-block");
    $("#lbl_DWislist_validation").addClass("d-none").removeClass("d-block");
    $("#lbl_Wislist_validation").hide();
    $("#lbl_Wislist_Length_Validation").hide();
    $("#lbl_Existing_validation").addClass("d-none").removeClass("d-block");
});

$(document).on('click', '.cart-items-page__save-in-wishlist .btn_SaveWishlist', function () {
    $("#save_as_wishlist_title").addClass("d-none").removeClass("d-block");
    $("#btnSaveAsWishlist").addClass("d-none").removeClass("d-block");
    $("#lbl_DWislist_validation").addClass("d-none").removeClass("d-block");
    $("#lbl_Wislist_validation").hide();
    $("#lbl_Wislist_Length_Validation").hide();
    $("#lbl_Existing_validation").addClass("d-none").removeClass("d-block");
});
$("#btnSaveAsWishlist").click(function () {
    
    if (validateForm()) {
        if (createNew) {
            if (saveCartToWishlist) {
                addCartToNewWishList();
                return;
            }
            addQuickCartToNewWishList();
        }
        else {
            if (saveCartToWishlist) {
                addCartToExistingWishList();
                return;
            }
            addQuickCartToExistingWishList();
        }
    }
})
function validateForm() {
    var isValid = true;
    var wishlistName = $('#saveInWishlistModal #saveWishListName').val();
    $("#lbl_Wislist_Length_Validation").hide();
    $("#lbl_Wislist_validation").hide();
    $("#lbl_Existing_validation").hide();
    $("#lbl_DWislist_validation").addClass('d-none').removeClass('d-block');

    if (createNew) {
        if (wishlistName == '') {
            $("#lbl_Wislist_validation").show();
            isValid = false;
        }
        else if (wishlistName.length > 35)
        {
            $("#lbl_Wislist_Length_Validation").show();
            isValid = false;
        }
        else if (checkWishListIsAvailable() == true)
        {
            $("#lbl_Existing_validation").show();
            isValid = false;
        }
        else {
            $("#lbl_Wislist_validation").hide();
            $("#lbl_Existing_validation").hide();
            $("#lbl_Wislist_Length_Validation").hide();
        }
    }
    else {
        if (wishlistSelected && wishlistSelected.length == 0) {
            $("#lbl_DWislist_validation").addClass('d-block').removeClass('d-none');
            isValid = false;
        }
        else {
            $("#lbl_DWislist_validation").addClass('d-none').removeClass('d-block');
        }
    }

    return isValid;
}
async function addToNewWishList() {
    var wishListName = $('#saveInWishlistModal #saveWishListName').val();
    var oc = $('#product-detail-page-odp input[name=oc]').val();
    var qty = $('#quantity_' + code).val();
    var data = {
        Code: code,
        Quantity: qty,
        OrderingCode: oc,
        WishLists: [wishListName]
    };
    let wishlistCsv = wishListName
    if (Array.isArray(wishListName)){
        wishlistCsv = wishlistCsv.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishListsPage/AddItemToNewWishlist",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response.success) {
                $('#saveInWishlistModal').modal('hide');
                var successMessage = $('#saveAsSuccess').data('msg');
                successMessage = successMessage.replace("{0}", '<b>' + response.code + '</b>');
                successMessage = successMessage.replace("{1}", '<b>' + response.wishListName + '</b>');
                $('#saveAsSuccess').html(successMessage);
                $('#saveAsSuccess').addClass('d-block');
                $('#wishListNameHidden').val(response.wishListName);
                $('#successWishlistModal').modal('show');
                odpUtils.TrackAddToWishlist(code, wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}
async function addToExisting() {
    var qty = $('#quantity_' + code).val();
    var oc = $('#product-detail-page-odp input[name=oc]').val();
    var data = {
        Code: code,
        Quantity: qty,
        OrderingCode: oc,
        WishLists: wishlistSelected
    };
    let wishlistCsv = wishlistSelected
    if (Array.isArray(wishlistSelected)){
        wishlistCsv = wishlistCsv.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishListsPage/AddItemToWishlists",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response.success) {
                $('#saveInWishlistModal').modal('hide');
                var successMessage = $('#saveToSuccess').data('msg');
                successMessage = successMessage.replace("{0}", '<b>' + response.code + '</b>');
                $('#saveToSuccess').html(successMessage);
                $('#saveToSuccess').addClass('d-block');
                $('#wishListNameHidden').val(response.wishListName);
                $('#successWishlistModal').modal('show');
                odpUtils.TrackAddToWishlist(code, wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}

async function addCartItemToNewWishList() {
    var wishListName = $('#saveInWishlistModal #saveWishListName').val();
    var data = {
        Code: cartItemMaterialId,
        Quantity: cartItemQuantity,
        OrderingCode: cartItemOrderingCode,
        WishLists: [wishListName]
    };
    let wishlistCsv = wishListName
    if (Array.isArray(wishListName)){
        wishlistCsv = wishlistCsv.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishList/SaveCartItemToWishlist",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response) {
                $('#saveInWishlistModal').modal('hide');
                var successMessage = $('#saveAsSuccess').data('msg');
                successMessage = successMessage.replace("{0}", '<b>' + cartItemMaterialId + '</b>');
                successMessage = successMessage.replace("{1}", '<b>' + wishListName + '</b>');
                $('#saveAsSuccess').html(successMessage);
                $('#saveAsSuccess').addClass('d-block');
                $('#wishListNameHidden').val(wishListName);
                $('#successWishlistModal').modal('show');
                odpUtils.TrackAddToWishlist(cartItemMaterialId, wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}

async function addCartItemToExisting() {
    var data = {
        Code: cartItemMaterialId,
        Quantity: cartItemQuantity,
        OrderingCode: cartItemOrderingCode,
        WishLists: wishlistSelected
    };
    let wishlistCsv = wishlistSelected
    if (Array.isArray(wishlistSelected)){
        wishlistCsv = wishlistCsv.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishList/SaveCartItemToWishlist",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response) {
                $('#saveInWishlistModal').modal('hide');
                var successMessage = $('#saveToSuccess').data('msg');
                successMessage = successMessage.replace("{0}", '<b>' + cartItemMaterialId + '</b>');
                $('#saveToSuccess').html(successMessage);
                $('#saveToSuccess').addClass('d-block');
                $('#wishListNameHidden').val(response.wishListName);
                $('#successWishlistModal').modal('show');
                odpUtils.TrackAddToWishlist(cartItemMaterialId, wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}

async function addQuickCartToNewWishList() {
    var wishListName = $('#saveInWishlistModal #saveWishListName').val();
    var data = {
        WishLists: [wishListName]
    };
    let $materials = $('.material-id');
    let materials = []
    if ($materials.length > 0){
        for (var i = 0; i < $materials.length - 1; i++){
            materials.push($($materials[i]).val());
        }
    }
    let wishlistCsv = wishListName
    if (Array.isArray(wishListName)){
        wishlistCsv = wishlistCsv.toString();
    }
    if (Array.isArray(materials)){
        materials = materials.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishList/SaveQuickCartItemsToWishlist",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response) {
                $('#saveInWishlistModal').modal('hide');
                $('#saveAsSuccessQuickCart').addClass("d-block").removeClass("d-none");
                $('#wishListNameHidden').val(wishListName);
                $('#successWishlistModal').modal('show');
                odpUtils.TrackCreateWishListFromQuickCart(materials, wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}

async function addQuickCartToExistingWishList() {
    var data = {
        WishLists: wishlistSelected
    };
    let $materials = $('.material-id');
    let materials = []
    if ($materials.length > 0){
        for (var i = 0; i < $materials.length - 1; i++){
            materials.push($($materials[i]).val());
        }
    }
    let wishlistCsv = wishlistSelected
    if (Array.isArray(wishlistSelected)){
        wishlistCsv = wishlistCsv.toString();
    }
    if (Array.isArray(materials)){
        materials = materials.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishList/SaveCartItemsToWishlist",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response) {
                $('#saveInWishlistModal').modal('hide');
                $('#saveToSuccessQuickCart').addClass("d-block").removeClass("d-none");
                $('#successWishlistModal').modal('show');
                odpUtils.TrackCreateWishListFromQuickCart(materials, wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}

async function addCartToNewWishList() {
    var wishListName = $('#saveInWishlistModal #saveWishListName').val();
    var data = {
        WishLists: [wishListName]
    };
    let wishlistCsv = wishListName
    if (Array.isArray(wishListName)){
        wishlistCsv = wishlistCsv.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishList/SaveCartItemsToWishlist",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response) {
                $('#saveInWishlistModal').modal('hide');
                $('#saveAsSuccessQuickCart').addClass("d-block").removeClass("d-none");
                $('#wishListNameHidden').val(wishListName);
                $('#successWishlistModal').modal('show');
                odpUtils.TrackAddFromCartToWishlist(wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}

async function addCartToExistingWishList() {
    var data = {
        WishLists: wishlistSelected
    };
    let wishlistCsv = wishlistSelected
    if (Array.isArray(wishlistSelected)){
        wishlistCsv = wishlistCsv.toString();
    }
    await $.ajax({
        type: "POST",
        url: "/WishList/SaveCartItemsToWishlist",
        data: JSON.stringify(data),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response) {
                $('#saveInWishlistModal').modal('hide');
                $('#saveToSuccessQuickCart').addClass("d-block").removeClass("d-none");
                $('#successWishlistModal').modal('show');
                odpUtils.TrackAddFromCartToWishlist(wishlistCsv);
                return;
            }
            else {
                $('#saveInWishlistModal').modal('hide');
            }
        },
        failure: function (response) {
            $('#saveInWishlistModal').modal('hide');
        },
        error: function (response) {
            $('#saveInWishlistModal').modal('hide');
        }
    });
}
$('#saveInWishlistModal').on('show.bs.modal', function (event) {
    createNew = false;
    var parentElement = $(event.relatedTarget).parentsUntil(".cart-items-page__cart-content").get(-1);
    cartItemMaterialId = $(parentElement).prev().find(".cart-sku-value").text();
    var productUrl = $(parentElement).prev().prev().find(".h7").parent().attr("href");
    if (productUrl)
    {
        cartItemOrderingCode = getQueryParameterValue(productUrl, "ORDER_CODE");
    }
    cartItemQuantity = $(parentElement).prev().prev().find(".cart-items-page__qty-row input[name=Qty]").val();

    code = $(event.relatedTarget).data('materialid');
    saveCartToWishlist = $(event.relatedTarget).data('cart');
    if (code || cartItemMaterialId) {
        $("#save_in_wishlist_title").addClass("d-block").removeClass("d-none");
        $("#btnSaveWishlist").addClass("d-block").removeClass("d-none");
    }
    else {
        $("#save_as_wishlist_title").addClass("d-block").removeClass("d-none");
        $("#btnSaveAsWishlist").addClass("d-block").removeClass("d-none");
    }
    $(selectBtn).removeClass("open");
    items.forEach(function (node) {
        $(node).removeClass('checked');
        $(node).prop('checked', false);
        wishlistSelected = [];
    })
    $(this).find("#chbCreateNew").prop('checked', false);
    $('.multiple-select-container .btn-text').text("select");
    $(this).find('#saveWishListName').addClass('d-none').removeClass('d-block');
    $(this).find('#lbl_wishListName').addClass('d-none').removeClass('d-block');
    $(this).find('#drpWishlist').addClass('d-block').removeClass('d-none');
    $(this).find('#lbl_drpWishlist').addClass('d-block').removeClass('d-none');
    $(this).find(".multiple-select-container").show();
});

$("#saveInWishlistModal").click(function () {
    $(selectBtn).removeClass("open");
});
$('#successWishlistModal').on('hidden.bs.modal', function () {
    $('#successWishlistModal #saveAsSuccess').addClass('d-none').removeClass('d-block');
    $('#successWishlistModal #saveToSuccess').addClass('d-none').removeClass('d-block');
    $('#successWishlistModal #saveToSuccessQuickCart').addClass('d-none').removeClass('d-block');
    $('#successWishlistModal #saveAsSuccessQuickCart').addClass('d-none').removeClass('d-block');
    $('#saveInWishlistModal #saveWishListName').val('');
})
function getQueryParameterValue(url, param) {
    var paramValue = "";
    var queryStart = url.indexOf("?") + 1;
    var queryEnd = url.indexOf("#") !== -1 ? url.indexOf("#") : url.length;
    var query = url.slice(queryStart, queryEnd);
    var queryArr = query.split("&");

    for (var i = 0; i < queryArr.length; i++) {
        var pair = queryArr[i].split("=");
        if (decodeURIComponent(pair[0]) === param) {
            paramValue = decodeURIComponent(pair[1]);
            break;
        }
    }

    return paramValue;
}
async function checkWishListIsAvailable() {
    var wishListExisted = false;
    await $.ajax({
        type: "GET",
        async: false,
        url: "/WishListsPage/CheckWishListIsAvailable",
        data: { 'wishListName': $('#saveInWishlistModal #saveWishListName').val() },
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
            if (response == true)
            {
                wishListExisted = true;
            }
        },
        failure: function (response) {
        },
        error: function (response) {
        }
    });
    return wishListExisted;
}

